import axios from '../../../utils/axios';
import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  isLoading: false,
  error: false,
  applications: null, // List of applications user has access to
  data: [],
};

const slice = createSlice({
  name: 'overview',
  initialState,
  reducers: {
    startLoading(state) {
      state.isLoading = true;
      state.error = false;
    },

    hasError(state, action) {
      state.isLoading = false;
      state.error = action.payload;
    },

    overviewSuccess(state, action) {
      state.isLoading = false;
      state.applications = action.payload.applications;
      state.data = action.payload.metrics;
    },
  },
});

export default slice.reducer;

export function getAdminOverview(customerId) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.get(`/admin/${customerId}/overview`);
      dispatch(slice.actions.overviewSuccess(response));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}
